export const FETCH_PRICES_SUCCEEDED = 'FETCH_PRICES_SUCCEEDED';
export const FETCH_EXCHANGE_RATE_FALLBACK = 'FETCH_EXCHANGE_RATE_FALLBACK';
export const FETCH_PRICES_FAILED = 'FETCH_PRICES_FAILED';
export const FETCH_EXCHANGE_RATE = 'FETCH_EXCHANGE_RATE';


export const LOAD_PRICE_FOR_ASSET_AND_CURRENCY = 'LOAD_PRICE_FOR_ASSET_AND_CURRENCY';

export const SAVE_COIN_GECKO_IDS = 'SAVE_COIN_GECKO_IDS';
